export default "__VITE_ASSET__fA9DMQTn__"